module.exports = __webpack_public_path__ + "img/footer-icon-1.19ac4022.png";